module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-5.svg";